"use client";

import { Menu, X } from "lucide-react";
import { useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  if (loading) {
    return <div className="flex gap-1">
        <div className="h-9 w-16 bg-muted-light animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted-light animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted-light animate-pulse rounded-md" />
      </div>;
  }
  const colorVars = ['var(--color-primary)', 'var(--color-secondary)', 'var(--color-accent)'];
  return <>
      {}
      <NavigationMenu viewport={false} className="hidden md:flex">
        <NavigationMenuList>
          {menuItems.map((item, i) => {
          const colorIndex = i % colorVars.length;
          const itemColorVar = colorVars[colorIndex];
          const isContactUs = i === 2;
          const isSolutions = i === 0;
          const isAboutUs = i === 1;
          return <NavigationMenuItem key={item.id} data-index={i}>
                <NavigationMenuLink asChild className={`group/nav-item transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] hover:-translate-y-0.5 ${isSolutions ? 'hover:!bg-[#d7df23] data-[active=true]:!bg-[#d7df23] focus:!bg-[#d7df23]' : ''} ${isContactUs ? 'hover:!bg-[#d7df23] data-[active=true]:!bg-[#d7df23] focus:!bg-[#d7df23]' : ''} ${isAboutUs ? 'hover:!bg-[#d7df23] data-[active=true]:!bg-[#d7df23] focus:!bg-[#d7df23]' : ''}`}>
                  <Link to={item.href || "#"} className="px-4 py-2 text-sm font-medium text-foreground relative transition-colors duration-[var(--duration-medium)]" style={{
                '--item-color': itemColorVar
              } as React.CSSProperties}>
                    <span className="relative">{item.label}<span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-0 h-0.5 transition-all duration-[var(--duration-medium)] group-hover/nav-item:w-3/4" style={{
                    backgroundColor: isSolutions || isContactUs || isAboutUs ? '#d7df23' : itemColorVar
                  }} /></span>
                  </Link>
                </NavigationMenuLink>
              </NavigationMenuItem>;
        })}
        </NavigationMenuList>
      </NavigationMenu>

      {}
      <Button variant="ghost" size="icon" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden p-2 text-foreground transition-all duration-[var(--duration-medium)] focus-ring hover:-translate-y-0.5 hover:text-primary" aria-label="Toggle menu">
        {mobileMenuOpen ? <X className="size-6" /> : <Menu className="size-6" />}
      </Button>

      {}
      {mobileMenuOpen && <div className="absolute top-full left-0 right-0 bg-background border-t border-border shadow-medium md:hidden z-50">
          <nav className="flex flex-col py-2">
            {menuItems.map((item, i) => {
          const colorIndex = i % colorVars.length;
          const itemColorVar = colorVars[colorIndex];
          const isContactUs = i === 2;
          const isSolutions = i === 0;
          const isAboutUs = i === 1;
          return <Link key={item.id} to={item.href || "#"} data-index={i} className={`group/mobile-item px-6 py-3 text-sm font-medium text-foreground transition-all duration-[var(--duration-medium)] border-b border-border last:border-b-0 relative overflow-hidden ${isSolutions || isContactUs || isAboutUs ? 'hover:!bg-[#d7df23]/20' : 'hover:bg-accent/10'}`} onClick={() => setMobileMenuOpen(false)} style={{
            '--mobile-item-color': itemColorVar
          } as React.CSSProperties}>
                  <span className="relative z-10">{item.label}</span>
                  <span className="absolute left-0 top-0 bottom-0 w-1 transition-all duration-[var(--duration-medium)] group-hover/mobile-item:w-1.5" style={{
              backgroundColor: isSolutions || isContactUs || isAboutUs ? '#d7df23' : itemColorVar
            }} />
                </Link>;
        })}
          </nav>
        </div>}
    </>;
}
export default function Header() {
  return <header className="bg-background border-b border-border shadow-soft sticky top-0 z-40">
      <div className="container mx-auto px-4 py-3 flex items-center justify-between">
        {}
        <Link to="/" className="flex-shrink-0 focus-ring rounded-md">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1432141/img/Activate logo.png" alt="Activate" className="h-13 logo" />
        </Link>

        {}
        <MenuProvider menu_id="20" className="flex items-center">
          <HeaderMenuConsumer />
        </MenuProvider>
      </div>
    </header>;
}